import { render, staticRenderFns } from "./TextCenterIcon.vue?vue&type=template&id=69dee0f1&"
import script from "./TextCenterIcon.vue?vue&type=script&lang=js&"
export * from "./TextCenterIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports